var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_shift_form_editTitle")
        : _vm.$t("label_essweb_shift_form_viewTitle"),
      pad: "0",
      widthClass: "max-1000",
      delBtn: _vm.hasBtn("delete-admin-shift"),
      editBtn: !_vm.iSEdited && _vm.hasBtn("edit-admin-shift"),
      initData: _vm.shiftData,
      checkData: [
        "shift_name",
        "sequence",
        "shift_description",
        "shift_abbr",
        "start_utc_time",
        "end_utc_time",
        "shift_type_uuid",
        "shift_code",
        "total_working_minutes",
        "color_code",
        "default_site_uuid",
        "effective_utc_datetime",
        "expired_utc_datetime",
        "shift_property_group_uuid",
        "remarks",
      ],
    },
    on: {
      edit: function ($event) {
        _vm.iSEdited = true
      },
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_shift_list_title"))
          .then(function (res) {
            res ? _vm.toDeleteShift() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: { curTab: _vm.curTab, items: _vm.taber },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "pa-2",
                          attrs: { "lazy-validation": "" },
                        },
                        [
                          _c(
                            "v-row",
                            { staticClass: "white lighten-5" },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      bindData: _vm.shiftData.shift_name,
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_shift_form_shiftNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.shiftData.shift_name = valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_shift_form_shiftAbbrLabel"
                                      ),
                                      readonly: !_vm.iSEdited,
                                      maxlength: "20",
                                      filled: _vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      placeholder: _vm.$t(
                                        "label_essweb_shift_form_shiftAbbrLabel"
                                      ),
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.shiftData.shift_abbr,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "shift_abbr",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.shift_abbr",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "4",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_ClaimReason_form_codeLabel"
                                      ),
                                      maxlength: "100",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules", "_Length_Rules"],
                                        [null, 100]
                                      ),
                                    },
                                    model: {
                                      value: _vm.shiftData.shift_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "shift_code",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.shift_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "4",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_shift_form_sequenceLabel"
                                      ),
                                      maxlength: "255",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      type: "number",
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 255]
                                      ),
                                    },
                                    model: {
                                      value: _vm.shiftData.sequence,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.shiftData, "sequence", $$v)
                                      },
                                      expression: "shiftData.sequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "4",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_shift_form_tagColorLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("SelectColor", {
                                    attrs: {
                                      items: _vm.Colors,
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      appendIcon: _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    model: {
                                      value: _vm.shiftData.color_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "color_code",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.color_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      maxlength: "500",
                                      bindData: _vm.shiftData.shift_description,
                                      label: _vm.$t(
                                        "label_essweb_shift_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.shiftData.shift_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-1",
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("Tabler", {
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.desserts,
                                      border: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.type",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      item.event_type_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.name",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      item.event_business_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.startTime",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$timeMachine(
                                                      item.start_utc_time
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.endTime",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$timeMachine(
                                                      item.end_utc_time
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.total",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    Number(item.end_utc_time) -
                                                      Number(
                                                        item.start_utc_time
                                                      )
                                                  ) +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "label_essweb_system_minutesLabel"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.group",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toViewProperty(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons-round",
                                                    },
                                                    [_vm._v("search")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.action",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _vm.iSEdited && false
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        disabled: !_vm.iSEdited,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toEditMapping(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("edit")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.iSEdited
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        disabled: !_vm.iSEdited,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toDelete(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("delete")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        _vm.iSEdited
                                          ? {
                                              key: "footer",
                                              fn: function () {
                                                return [
                                                  _c("v-divider"),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "text-capitalize my-2 text-button",
                                                      attrs: {
                                                        text: "",
                                                        disabled: !_vm.iSEdited,
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: _vm.toNewMapping,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_shift_form_addEventBtnLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("add")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "text--secondary pl-1 text-left",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_shift_form_totalMinutesLabel"
                                          ) + " "
                                        ) +
                                          ":" +
                                          _vm._s(_vm.totalMin) +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_system_minutesLabel"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("AutoComplete", {
                                    attrs: {
                                      isRequired: "",
                                      items: _vm.ShiftTypeList,
                                      "item-text": "shift_type_name",
                                      label:
                                        "label_essweb_shift_form_shiftTypeLabel",
                                      filled: _vm.iSEdited,
                                      "small-chips": "",
                                      "item-value": "uuid",
                                      readonly: !_vm.iSEdited,
                                      chips: "",
                                      rules: _vm.$GetRules(
                                        ["_Require_ArrRules"],
                                        [null]
                                      ),
                                      multiple: "",
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      "deletable-chips": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.shift_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.title",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.shift_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.shiftData.shift_type_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "shift_type_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.shift_type_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("AutoComplete", {
                                    attrs: {
                                      items: _vm.defaultSiteList,
                                      "item-text": "site_name",
                                      label:
                                        "label_essweb_shift_form_siteNameLabel",
                                      "item-value": "uuid",
                                      "small-chips": "",
                                      chips: "",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      "deletable-chips": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.site_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.title",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.site_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.shiftData.default_site_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "default_site_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.default_site_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("DateTimePicker", {
                                    attrs: {
                                      type: "date",
                                      placeholder: "YYYY/MM/DD",
                                      filled: _vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_shift_form_effectiveDateLabel"
                                      ),
                                      defaultTime:
                                        _vm.shiftData.effective_utc_datetime,
                                      max: _vm.shiftData.expired_utc_datetime,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.shiftData.effective_utc_datetime =
                                          time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("DateTimePicker", {
                                    attrs: {
                                      min: _vm.shiftData.effective_utc_datetime,
                                      defaultTime:
                                        _vm.shiftData.expired_utc_datetime,
                                      label: _vm.$t(
                                        "label_essweb_shift_form_expireDateLabel"
                                      ),
                                      type: "date",
                                      placeholder: "YYYY/MM/DD",
                                      filled: _vm.iSEdited,
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.shiftData.expired_utc_datetime =
                                          time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_shift_form_timeZoneLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.staticZone,
                                      filled: _vm.iSEdited,
                                      "single-line": "",
                                      readonly: !_vm.iSEdited,
                                      "item-text": "text",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      "item-value": "utc",
                                      label: _vm.$t(
                                        "label_essweb_shift_form_timeZoneLabel"
                                      ),
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.shiftData.expired_time_zone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "expired_time_zone",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.expired_time_zone",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("AutoComplete", {
                                    attrs: {
                                      isRequired: "",
                                      "small-chips": "",
                                      items: _vm.ShiftPorpertyGroup,
                                      "item-text": "shift_property_group_name",
                                      "item-value": "uuid",
                                      label:
                                        "label_essweb_shift_form_shiftPropertyGroupLabel",
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      placeholder: _vm.$t(
                                        "label_essweb_shift_form_shiftPropertyGroupLabel"
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item
                                                      .shift_property_group_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.title",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item
                                                      .shift_property_group_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.shiftData.shift_property_group_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "shift_property_group_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "shiftData.shift_property_group_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-sheet",
                        {
                          staticClass:
                            "max-width pa-3 d-flex flex-row justify-space-between",
                          attrs: { height: "50" },
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_shift_form_step_punchMethodLabel"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("v-spacer"),
                          _c(
                            "div",
                            { staticClass: "text-right align-right" },
                            [
                              _vm.iSEdited
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize mx-2",
                                      attrs: {
                                        rounded: "",
                                        outlined: "",
                                        disabled:
                                          !_vm.iSEdited || _vm.isLoading,
                                        text: "",
                                        color: "primary",
                                      },
                                      on: { click: _vm.toCopyFromShift },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_shift_form_copyFromAnotherShift"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.iSEdited
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize mx-2",
                                      attrs: {
                                        rounded: "",
                                        outlined: "",
                                        text: "",
                                        disabled:
                                          !_vm.iSEdited || _vm.isLoading,
                                        color: "primary",
                                      },
                                      on: { click: _vm.toAddGroup },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_shift_form_addSiteBtnLabel"
                                          )
                                        )
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("add")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.SiteMappingData.length ? _c("noContent") : _vm._e(),
                      _vm._l(_vm.SiteMappingData, function (item, index) {
                        return _c("SpecialTable", {
                          key: index,
                          attrs: {
                            isHead: "",
                            readonly: !_vm.iSEdited,
                            headers: _vm.siteHeader,
                            showFooter: "",
                            tableTitle: item.site_name,
                            type: "site",
                            type_uuid: item.site_uuid,
                            items: item.items ? item.items : [],
                            newBtn: "label_essweb_shift_form_criteriaTypeLabel",
                          },
                          on: {
                            onNew: _vm.toAddCriteriaType,
                            onDelete: _vm.toDeleteCriteriaType,
                            onDeleteGroup: function ($event) {
                              return _vm.toDeleteGroup(item.site_uuid)
                            },
                          },
                        })
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited && _vm.curTab == "tab-1"
              ? _c("CardActions", {
                  attrs: { saveBtn: _vm.curTab == "tab-1" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newCriteriaTypeDialog", {
              attrs: { show: _vm.showCriteriaTypeDialog, site: _vm.curSite },
              on: {
                close: function ($event) {
                  _vm.showCriteriaTypeDialog = false
                },
                new: _vm.onNewCriteriaType,
              },
            }),
            _c("mapEventShift", {
              attrs: {
                show: _vm.mapToDialog,
                action: _vm.curAction,
                mapData: _vm.curMapData,
              },
              on: {
                closeDialog: function ($event) {
                  _vm.mapToDialog = false
                },
                new: _vm.onNewMapping,
                edit: _vm.onEditMapping,
              },
            }),
            _c("newGroupMapping", {
              attrs: { show: _vm.newGroupMapDialog },
              on: {
                new: _vm.toNewGroup,
                close: function ($event) {
                  _vm.newGroupMapDialog = false
                },
              },
            }),
            _c("copyFromShift", {
              attrs: {
                show: _vm.showCopyShift,
                curentShift: _vm.$route.params.id,
              },
              on: {
                close: function ($event) {
                  _vm.showCopyShift = false
                },
                new: _vm.onCopyFromShift,
              },
            }),
            _c("viewProperty", {
              attrs: {
                show: _vm.showPropertyList,
                group_uuid: _vm.curGroupUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showPropertyList = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }